var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoProgramFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4292 63.2174L66.2667 54.3799L91.25 79.3632L82.4125 88.2007L57.4292 63.2174ZM72.9167 41.6674C80.9583 41.6674 87.5 35.1257 87.5 27.0841C87.5 24.6674 86.8333 22.4174 85.7917 20.4174L74.5417 31.6674L68.3333 25.4591L79.5833 14.2091C77.5833 13.1674 75.3333 12.5007 72.9167 12.5007C64.875 12.5007 58.3333 19.0424 58.3333 27.0841C58.3333 28.7924 58.6667 30.4174 59.2083 31.9174L51.5 39.6257L44.0833 32.2091L47.0417 29.2507L41.1667 23.3757L50 14.5424C47.6562 12.2015 44.4792 10.8867 41.1667 10.8867C37.8542 10.8867 34.6771 12.2015 32.3333 14.5424L17.5833 29.2924L23.4583 35.1674H11.7083L8.75 38.1257L23.5 52.8757L26.4583 49.9174V38.1257L32.3333 44.0007L35.2917 41.0424L42.7083 48.4591L11.8333 79.3341L20.6667 88.1674L68.0833 40.7924C69.5833 41.3341 71.2083 41.6674 72.9167 41.6674Z",
    fill: "#FCC046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProgramFound);
export default __webpack_public_path__ + "static/media/no-program-found.a1a8b753ad0085ce643a86b83a6140b8.svg";
export { ForwardRef as ReactComponent };